import React, { useEffect, useState } from "react";
import BlogImg from "../assets/img/serviceBg.png";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";

const PostsComponent = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  // Function to format dates
  const timeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    const timeUnits = [
      { unit: "year", seconds: 31536000 },
      { unit: "month", seconds: 2592000 },
      { unit: "week", seconds: 604800 },
      { unit: "day", seconds: 86400 },
      { unit: "hour", seconds: 3600 },
      { unit: "minute", seconds: 60 },
      { unit: "second", seconds: 1 },
    ];

    for (const { unit, seconds } of timeUnits) {
      const interval = Math.floor(diffInSeconds / seconds);
      if (interval >= 1) {
        return `${interval} ${unit}${interval !== 1 ? "s" : ""} ago`;
      }
    }
    return "just now";
  };

  // Fetch posts with pagination
  useEffect(() => {
    setLoading(true);
    fetch(
      `https://blog.365globalconsulting.com/wp-json/wp/v2/posts?_embed&per_page=9&page=${currentPage}`
    )
      .then((response) => {
        const total = response.headers.get("X-WP-TotalPages");
        setTotalPages(Number(total));
        return response.json();
      })
      .then((data) => {
        setPosts(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching posts:", error);
        setLoading(false);
      });
  }, [currentPage]);

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  //   if (loading) {
  //     return (
  //       <div className="container mx-auto flex justify-center items-center">
  //         <Loader />
  //       </div>
  //     );
  //   }

  return (
    <div className="container mx-auto pt-10 md:pt-40">
      {loading ? (
        <Loader />
      ) : (
        <div className="flex flex-wrap gap-8 justify-between px-4 md:px-12">
          {posts.map((post) => (
            <div key={post.id} className="md:w-[520px] h-[550px]">
              <div className="relative w-full h-[300px] md:h-[300px] overflow-hidden group rounded-3xl">
                <img
                  onClick={() => navigate(`/blog/${post.id}`)}
                  src={
                    post._embedded &&
                    post._embedded["wp:featuredmedia"] &&
                    post._embedded["wp:featuredmedia"][0].source_url
                      ? post._embedded["wp:featuredmedia"][0].source_url
                      : BlogImg
                  }
                  alt={post.title.rendered}
                  className="md:min-w-[320px] min-h-[300px] object-cover transition-transform duration-700 group-hover:scale-110 cursor-pointer"
                />
              </div>
              <div onClick={() => navigate(`/press/${post.id}`)}>
                <p className="text-xl pt-2">{post.title.rendered}</p>
                <p className="text-sm text-gray-500">
                  {timeAgo(post.date)}
                </p>{" "}
              </div>
              <button
                className="bg-gray-neutral px-4 py-2 rounded-md text-primary mt-6 hover:bg-gray-cool hover:text-white duration-500"
                onClick={() => navigate(`/blog/${post.id}`)}
              >
                Read more
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Pagination Buttons */}
      <div className="flex justify-center items-center gap-4 mt-8">
        <button
          className="px-4 py-2 bg-gray-200 rounded"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            className={`px-3 py-1 rounded-full ${
              currentPage === index + 1
                ? "bg-primary text-white"
                : "bg-gray-200"
            }`}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </button>
        ))}
        <button
          className="px-4 py-2 bg-gray-200 rounded"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PostsComponent;
